import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartOptions,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import "./CategoryBarChart.css";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface CategoryBarChartProps {
  categoryCountMap: Record<string, number>;
  isDarkmodeActive: boolean;
}

const CategoryBarChart: React.FC<CategoryBarChartProps> = ({ categoryCountMap, isDarkmodeActive }) => {
  
  const labels = Object.keys(categoryCountMap);
  const dataValues = Object.values(categoryCountMap);

  const BAR_HEIGHT = 5;
  const GAP_BETWEEN_BARS = 0.3;
  const PADDING_TOP_BOTTOM = 2;
  const totalHeightRem = labels.length * (BAR_HEIGHT + GAP_BETWEEN_BARS) + PADDING_TOP_BOTTOM;

  const textColor = isDarkmodeActive ? "#ffffff" : "#000000";
  const barColor = isDarkmodeActive ? "rgba(59,130,246,0.8)" : "rgba(37,99,235,0.8)";
  const tooltipBg = isDarkmodeActive ? "#1f2937" : "#ffffff"; 

  const data = {
    labels,
    datasets: [
      {
        label: "Classification Count",
        data: dataValues,
        backgroundColor: barColor,
        borderRadius: 6,
        barThickness: 30,
      },
    ],
  };

  const maxCount = Math.max(...dataValues, 0);

  const options: ChartOptions<"bar"> = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      title: {
        display: false,
        color: textColor,
      },
      tooltip: {
        backgroundColor: tooltipBg,
        titleColor: textColor,
        bodyColor: textColor,
        borderColor: isDarkmodeActive ? "#4B5563" : "#E5E7EB",
        borderWidth: 1,
      },
    },
    layout: {
      padding: 10,
    },
    scales: {
      x: {
        beginAtZero: true,
        suggestedMax: maxCount + 1,
        ticks: {
          color: textColor,
          precision: 0,
        },
        grid: {
          color: isDarkmodeActive ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)",
        },
      },
      y: {
        ticks: {
          color: textColor,
        },
        grid: {
          color: isDarkmodeActive ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)",
        },
      },
    },
  };

  return (
    <div className={`chart-container ${isDarkmodeActive ? "dark" : "light"}`}>
      <h2 className="chart-title">Classification Breakdown</h2>
      <div className="chart-background" style={{ height: `${totalHeightRem}rem` }}>
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default CategoryBarChart;